import { ModularPriceTheme } from '../../types';

export const MODULAR_PRICE_DEFAULT_THEME: ModularPriceTheme = {
    currencySizeCoefficient: 0.6,
    fractionSizeCoefficent: 0.6,
    currencyFontWeight: 'semiBold',
    fractionFontWeight: 'semiBold',
};
